export const checkHttpStatus = (error: any, status: number): boolean => {
  if (error?.response?.status == null) {
    return false;
  }

  return Number(error.response.status) === status;
};

export const test = 1;
